import { useEffect, useState } from "react";
import { PublishMenuButtonProps } from "../../media-actions/items";
import { baseUrl, getKmsData, translate } from "@kaltura/mediaspace-shared-utils";
import { useToastsContext } from "@kaltura/mediaspace-shared-contexts/ToastsContext";

/**
 * React hook to load media publish status asynchronously - use it to build your own AsyncPublishMenuButton component.
 */
export function useAsyncPublishButton(entryId: string, isIdle = false): PublishMenuButtonProps {
    const [data, setData] = useState<PublishMenuButtonProps | null>(null);
    const [isLoading, setIsLoading] = useState(true);

    const { showToast } = useToastsContext();

    /**
     * get publish menu props
     */
    useEffect(() => {
        (async () => {
            try {
                setIsLoading(true);
                const url = `${baseUrl}/publishmedia/media/get-component-props/entryId/${entryId}`;
                const fetchedProps = await getKmsData(url);

                if (fetchedProps) {
                    setData(fetchedProps);
                }
            }
            catch (error) {
                console.error("Error getting publish button props for entry id:", entryId, error);
                showToast({ message: translate("Failed to load privacy status for the media"), severity: "error" });
            }
            finally {
                setIsLoading(false);
            }
        })();
    }, [entryId, showToast]);

    /**
     * update menu state data by publish response
     */
    const handleItemStateChange = (key: string, value: any) => {
        setData((prevData) => {
            if (!prevData) return null;
            return {
                ...prevData,
                [key]: value, // Update the key with the new value
            };
        });
    };

    return {
        entryIds: [entryId],
        isLoading: isIdle || isLoading,
        onItemStateChange: handleItemStateChange,
        ...data,
    };
}
